// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import locale from "element-ui/lib/locale/lang/en";
import ElementUI from 'element-ui'
// main.js 或者其他的 Vue 插件配置文件
import VueLazyload from 'vue-lazyload'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store';
import "@/assets/fonts/font.css";

Vue.config.productionTip = false
// Vue.use(ElementUI)
Vue.use(ElementUI, { locale });

Vue.use(VueLazyload, {
  // 设置懒加载时的占位图
  loading: require("./assets/img/loading.jpg")
  // // 设置图片加载失败时的占位图
  // error: "path/to/error-image.png"
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js